import { ActiveField } from '@alt-point/active-models/src'

import { ApiError } from './ApiError'
import type { RawApiError, RawApiErrors } from './types'

export class ApiValidationError extends ApiError {
  /**
   * Поле модели, с которым ассоциирована ошибка
   */
  @ActiveField()
  property?: string = undefined

  /**
   * Сообщения пояснений к свойству модели, указанном в `property`
   */
  @ActiveField()
  errors?: Record<string, string[]> = undefined

  static checkIs(error: RawApiError) {
    return error.status === 422
  }

  static getMessages(error?: RawApiErrors) {
    return error?.errors ? Object.values(error.errors).flat() : undefined
  }

  static getFieldMessage(error?: RawApiErrors, field?: string) {
    if (!field) {
      return undefined
    }

    return error?.errors?.[field]?.[0]
  }
}
